<template lang="html">
<div class="loader-wrapper" :class="{'full-page' : fullPage}">
  <div class="shadow" v-if="fullPage"></div>
  <div class="circle">
    <div class="center-circle">
      <div class="satellite-circle"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    fullPage: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>

$blue-color: #00AEEF;
$grey-color: #58595B;
$circle-size: 50px;
$border-size: 5px;
$circle-margin: 0px;
$satellite-size: 0px;
$satellite-margin: -10px;
$satellite-transform: 30px;

$circle-size-sm: 25px;
$border-size-sm: 3px;
$satellite-margin-sm: -7px;
$satellite-transform-sm: 16px;

@keyframes spinner {
  to {transform: rotate(360deg);}
}

.loader-wrapper {
  min-width: 30px;
  min-height: 30px;
  margin-inline: -15px;
  .circle {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2001;
    .center-circle {
      position: absolute;
      width: $circle-size-sm;
      height: $circle-size-sm;
      border: $border-size-sm solid $grey-color;
      border-radius: 100%;
    }
    .satellite-circle {
      position: absolute;
      width: $satellite-size;
      height: $satellite-size;
      top: $satellite-margin-sm;
      left: $satellite-margin-sm;
      border: $border-size-sm solid $blue-color;
      border-radius: 100%;
      animation: spinner 2s linear infinite;
      transform-origin: $satellite-transform-sm $satellite-transform-sm;
    }
  }
}

.full-page {
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  .shadow {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(123, 123, 123, 0.4);
    margin: 0;
    padding: 0;
    z-index: 2000;
    top: 0;
  }
  .circle {
    position: fixed;
    .center-circle {
      position: absolute;
      width: $circle-size;
      height: $circle-size;
      border: $border-size solid $grey-color;
      border-radius: 100%;
    }
    .satellite-circle {
      top: $satellite-margin;
      left: $satellite-margin;
      border: $border-size solid $blue-color;
      transform-origin: $satellite-transform $satellite-transform;
    }
  }
}

</style>
